(function () {
  var sec = document.getElementById('related');
  if (!sec) return;
  var url = sec.getAttribute('data-recs-url');
  var carousel = document.getElementById('related-carousel');
  if (!url || !carousel) return;

  fetch(url)
    .then(function (res) { return res.text(); })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var cards = doc.querySelectorAll('.product-card');
      if (cards.length < 4) return; // not enough true recommendations, keep collection fallback
      carousel.innerHTML = '';
      cards.forEach(function (card) { carousel.appendChild(card); });
    })
    .catch(function () { /* keep collection fallback on any error */ });
})();
